<template>
  <v-overlay absolute
             :value="loading"
  >
    <v-progress-circular indeterminate
                         size="160"
    />
  </v-overlay>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    value: { type: Boolean, default: false, }
  },
  computed: {
    loading () {
      return this.value
    }
  }
}
</script>

<style scoped>

</style>
